/* eslint-disable react/prop-types */
import React from 'react';
import { Text, Link } from '@fluentui/react-components';
import { MessageBar, MessageBarBody } from '@fluentui/react-message-bar';

export const BiddingStrategyWarning = ({ style, i18n }) => (
  <MessageBar className={style} intent="error" layout="singleline">
    <MessageBarBody>
      <Text size={200}>{i18n.getString(_TL_('To use this option, change bidding strategy to '))}</Text>
      <Text size={200} weight="bold">{i18n.getString(_TL_('Maximize conversion value. '))}</Text>
      <Link href="https://help.ads.microsoft.com/#apex/ads/en/56786/1" target="_blank" inline>{i18n.getString(_TL_('Learn more'))}</Link>
    </MessageBarBody>
  </MessageBar>
);

export const AccountLevelRequiredWarning = ({ style, i18n }) => (
  <MessageBar className={style} intent="error" layout="singleline">
    <MessageBarBody>
      <Text size={200}>{i18n.getString(_TL_('You need to set up your customer acquisition settings at the account level.'))}</Text>
    </MessageBarBody>
  </MessageBar>
);
